module.exports = __webpack_public_path__ + "img/chose.2e88ea11.png";